import {
  GetComisionPagadas,
  State as ComisionState
} from "../../../reducers/comisiones";

export interface ComisionesPagadasStore extends GetComisionPagadas {}

export const comisionesPagadasStore: (
  state
) => ComisionesPagadasStore = state => {
  const comisiones: ComisionState = state.comisiones;

  return {
    comisionesPagadas: comisiones.comisionesPagadas,
    gettingComisionesPagadas: comisiones.gettingComisionesPagadas,
    gettingComisionesPagadasError: comisiones.gettingComisionesPagadasError
  };
};
